document.documentElement.classList.remove('no-js');

(function () {
  const currency = window.Shopify?.currency?.active || 'EUR';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + ' €';
    }
  };

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerContent = drawer?.querySelector('[data-cart-content]');
  const drawerFooter = drawer?.querySelector('[data-cart-footer]');
  const drawerSubtotal = drawer?.querySelector('[data-cart-subtotal]');
  const drawerUpsell = drawer?.querySelector('[data-cart-upsell]');
  const duoPoolNode = document.querySelector('[data-cart-duo-pool]');
  let duoPool = [];
  try { duoPool = duoPoolNode ? JSON.parse(duoPoolNode.textContent || '[]') : []; } catch (error) { duoPool = []; }
  let lastFocused = null;

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));

  async function getCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Impossible de charger le panier.');
    return response.json();
  }

  async function renderCartUpsell(cart) {
    if (!drawerUpsell) return;
    drawerUpsell.hidden = true;
    drawerUpsell.innerHTML = '';
    if (!cart.items || !cart.items.length) return;

    const inCartProducts = new Set(cart.items.map((item) => Number(item.product_id)));
    const inCartVariants = new Set(cart.items.map((item) => Number(item.variant_id)));
    const leadProductId = Number(cart.items[cart.items.length - 1]?.product_id || cart.items[0].product_id);
    let product = null;
    let variant = null;

    try {
      let response = await fetch('/recommendations/products.json?product_id=' + leadProductId + '&limit=8&intent=complementary', { headers: { Accept: 'application/json' } });
      let data = response.ok ? await response.json() : { products: [] };
      if (!data.products || !data.products.length) {
        response = await fetch('/recommendations/products.json?product_id=' + leadProductId + '&limit=8&intent=related', { headers: { Accept: 'application/json' } });
        data = response.ok ? await response.json() : { products: [] };
      }
      product = (data.products || []).find((item) => !inCartProducts.has(Number(item.id)) && item.available && item.variants?.some((candidate) => candidate.available));
      if (product) variant = product.variants.find((candidate) => candidate.available && !inCartVariants.has(Number(candidate.id))) || product.variants.find((candidate) => candidate.available);
    } catch (error) {}

    if (!product || !variant) {
      const fallback = duoPool.find((item) => !inCartProducts.has(Number(item.product_id)) && !inCartVariants.has(Number(item.variant_id)) && item.available);
      if (fallback) {
        product = {
          id: fallback.product_id,
          title: fallback.title,
          url: fallback.url,
          featured_image: fallback.image
        };
        variant = { id: fallback.variant_id, price: fallback.price, available: true };
      }
    }

    if (!product || !variant) return;
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const duoTotal = Number(cart.total_price || 0) + Number(variant.price || 0);
    drawerUpsell.innerHTML = '<span class="cart-upsell__label">Offre duo recommandée</span><div class="cart-upsell__card">' +
      (image ? '<a class="cart-upsell__image" href="' + escapeHtml(product.url) + '"><img src="' + escapeHtml(image) + (String(image).includes('?') ? '&' : '?') + 'width=160" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : '<div></div>') +
      '<div><a class="cart-upsell__title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a><div class="cart-upsell__price">Ajoutez-le à votre commande · ' + money(variant.price) + '</div><div class="cart-upsell__duo-total">Total du duo : ' + money(duoTotal) + '</div></div>' +
      '<button class="button cart-upsell__add" type="button" data-quick-add data-variant="' + variant.id + '">Ajouter au duo</button></div>';
    drawerUpsell.hidden = false;
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
    });
    if (!drawerContent) return;

    if (!cart.items.length) {
      drawerContent.innerHTML = '<div class="cart-drawer__empty"><div class="cart-drawer__empty-icon">🛒</div><h3>Votre panier est vide</h3><p>Découvrez nos essentiels pour un espace plus confortable.</p><a class="button" href="/collections/all">Découvrir les produits</a></div>';
      if (drawerFooter) drawerFooter.hidden = true;
      if (drawerUpsell) drawerUpsell.hidden = true;
      return;
    }

    drawerContent.innerHTML = '<div class="cart-drawer__items">' + cart.items.map((item, index) => {
      const image = item.featured_image?.url || item.image || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '<article class="cart-drawer__item" data-cart-line="' + (index + 1) + '">' +
        (image ? '<a href="' + escapeHtml(item.url) + '" class="cart-drawer__image"><img src="' + escapeHtml(image) + '&width=240" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>' : '') +
        '<div class="cart-drawer__details"><a href="' + escapeHtml(item.url) + '" class="cart-drawer__title">' + escapeHtml(item.product_title) + '</a>' + variant +
        '<div class="cart-drawer__line-bottom"><div class="quantity quantity--small"><button type="button" data-cart-change="' + (index + 1) + '" data-new-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Diminuer la quantité">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change="' + (index + 1) + '" data-new-quantity="' + (item.quantity + 1) + '" aria-label="Augmenter la quantité">+</button></div><strong>' + money(item.final_line_price) + '</strong></div>' +
        '<button class="cart-drawer__remove" type="button" data-cart-change="' + (index + 1) + '" data-new-quantity="0">Supprimer</button></div></article>';
    }).join('') + '</div>';

    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    if (drawerFooter) drawerFooter.hidden = false;
    renderCartUpsell(cart);
  }

  async function refreshCart() {
    try { renderCart(await getCart()); }
    catch (error) { if (drawerContent) drawerContent.innerHTML = '<p>Le panier n’a pas pu être chargé. Veuillez réessayer.</p>'; }
  }

  function openDrawer(trigger) {
    if (!drawer) return;
    lastFocused = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
    setTimeout(() => drawer.querySelector('[data-cart-close]')?.focus(), 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastFocused?.focus?.();
  }

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    const close = event.target.closest('[data-cart-close]');
    if (open) { event.preventDefault(); openDrawer(open); }
    if (close) { event.preventDefault(); closeDrawer(); }

    const qty = event.target.closest('[data-qty]');
    if (qty) {
      const input = qty.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value) + (qty.dataset.qty === 'plus' ? 1 : -1));
    }

    const change = event.target.closest('[data-cart-change]');
    if (change) {
      change.disabled = true;
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(change.dataset.cartChange), quantity: Number(change.dataset.newQuantity) })
        });
        if (!response.ok) throw new Error();
        renderCart(await response.json());
      } catch (error) { await refreshCart(); }
    }

    const bundleAdd = event.target.closest('[data-bundle-add]');
    if (bundleAdd) {
      event.preventDefault();
      if (bundleAdd.disabled) return;
      bundleAdd.disabled = true;
      const old = bundleAdd.textContent;
      bundleAdd.textContent = 'Ajout du pack…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(bundleAdd.dataset.variantOne), quantity: 1 },
            { id: Number(bundleAdd.dataset.variantTwo), quantity: 1 }
          ] })
        });
        if (!response.ok) throw new Error('bundle');
        bundleAdd.textContent = 'Pack ajouté ✓';
        openDrawer(bundleAdd);
      } catch (error) {
        bundleAdd.textContent = 'Erreur — réessayez';
      } finally {
        setTimeout(() => { bundleAdd.textContent = old; bundleAdd.disabled = false; }, 1600);
      }
    }

    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault(); quickAdd.disabled = true;
      const old = quickAdd.textContent; quickAdd.textContent = 'Ajout…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(quickAdd.dataset.variant), quantity: 1 }] })
        });
        if (!response.ok) throw new Error();
        quickAdd.textContent = 'Ajouté ✓'; openDrawer(quickAdd);
      } catch (error) { quickAdd.textContent = 'Erreur'; }
      finally { setTimeout(() => { quickAdd.textContent = old; quickAdd.disabled = false; }, 1200); }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const counter = gallery.querySelector('[data-gallery-current]');
    let current = 0;
    let touchStart = 0;
    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === current); slide.setAttribute('aria-hidden', i === current ? 'false' : 'true'); });
      thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === current); thumb.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      thumbs[current]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (counter) counter.textContent = current + 1;
    };
    gallery.addEventListener('product:media-change', (event) => {
      const mediaId = String(event.detail?.mediaId || '');
      const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === mediaId);
      if (index >= 0) show(index);
    });
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    const viewport = gallery.querySelector('[data-gallery-viewport]');
    viewport?.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') show(current - 1); if (event.key === 'ArrowRight') show(current + 1); });
    viewport?.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    viewport?.addEventListener('touchend', (event) => { const delta = event.changedTouches[0].clientX - touchStart; if (Math.abs(delta) > 45) show(current + (delta < 0 ? 1 : -1)); }, { passive: true });
    gallery.querySelectorAll('[data-product-zoom]').forEach((zoom) => zoom.addEventListener('pointermove', (event) => { const rect = zoom.getBoundingClientRect(); zoom.style.setProperty('--zoom-x', ((event.clientX - rect.left) / rect.width * 100) + '%'); zoom.style.setProperty('--zoom-y', ((event.clientY - rect.top) / rect.height * 100) + '%'); }));
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const radios = [...form.querySelectorAll('input[type="radio"][name^="options"]')];
    const section = form.closest('[data-product-section]');
    const gallery = section?.querySelector('[data-product-gallery]');
    const priceWrap = section?.querySelector('[data-product-price]');
    const submit = form.querySelector('[data-add-to-cart]');

    const update = () => {
      const selected = radios.reduce((values, input) => { if (input.checked) values.push(input.value); return values; }, []);
      const option = [...select.options].find((item) => {
        try { return JSON.parse(item.dataset.options).every((value, index) => value === selected[index]); }
        catch (error) { return false; }
      });
      if (!option) return;
      select.value = option.value;
      option.selected = true;
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      if (priceWrap) {
        const price = Number(option.dataset.price); const compare = Number(option.dataset.compare || 0);
        priceWrap.innerHTML = '<span class="price">' + money(price) + '</span>' + (compare > price ? '<span class="compare-price">' + money(compare) + '</span><span class="saving-badge">Économisez ' + Math.round((compare - price) * 100 / compare) + '%</span>' : '');
      }
      if (option.dataset.mediaId) gallery?.dispatchEvent(new CustomEvent('product:media-change', { detail: { mediaId: option.dataset.mediaId } }));
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
    };

    radios.forEach((radio) => radio.addEventListener('change', () => {
      if (radio.dataset.optionMediaId) gallery?.dispatchEvent(new CustomEvent('product:media-change', { detail: { mediaId: radio.dataset.optionMediaId } }));
      update();
    }));
    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      try {
        const values = JSON.parse(option.dataset.options || '[]');
        radios.forEach((radio) => { radio.checked = values.includes(radio.value) && radio.name === radios.find((candidate) => candidate.value === radio.value)?.name ? radio.checked : radio.checked; });
      } catch (error) {}
      if (option.dataset.mediaId) gallery?.dispatchEvent(new CustomEvent('product:media-change', { detail: { mediaId: option.dataset.mediaId } }));
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit.disabled) return;
      submit.disabled = true; const old = submit.textContent; submit.textContent = 'Ajout en cours…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error();
        submit.textContent = 'Ajouté au panier ✓'; openDrawer(submit);
      } catch (error) { submit.textContent = 'Une erreur est survenue'; }
      finally { setTimeout(() => { submit.textContent = old; submit.disabled = false; }, 1300); }
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (section.querySelector('.recommendations-grid')) return;
    try {
      const response = await fetch(section.dataset.url); if (!response.ok) return;
      const html = await response.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector('[data-product-recommendations]');
      if (replacement && replacement.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (error) {}
  });
})();
